import { useState } from 'react';
import { Modal, Button, Input } from '@/components/common';
import { useCreateFolder } from '@/hooks/useFolders';
import styles from './FolderModal.module.css';

interface CreateFolderModalProps {
  isOpen: boolean;
  onClose: () => void;
}

export default function CreateFolderModal({ isOpen, onClose }: CreateFolderModalProps) {
  const [name, setName] = useState('');
  const createMutation = useCreateFolder();

  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    if (!name.trim()) return;

    createMutation.mutate(name.trim(), {
      onSuccess: () => {
        setName('');
        onClose();
      },
    });
  };

  return (
    <Modal isOpen={isOpen} onClose={onClose} title="Create New Folder" size="sm">
      <form onSubmit={handleSubmit} className={styles.form}>
        <Input
          label="Folder Name"
          value={name}
          onChange={(e) => setName(e.target.value)}
          placeholder="My Favorite Desserts"
          maxLength={50}
          autoFocus
        />
        <div className={styles.actions}>
          <Button type="submit" isLoading={createMutation.isPending} disabled={!name.trim()}>
            Create Folder
          </Button>
          <Button type="button" variant="secondary" onClick={onClose}>
            Cancel
          </Button>
        </div>
      </form>
    </Modal>
  );
}
